<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de Cortes de Caja</h5>
        <small
          style="color: gray" class="font-weight-bold"
        > Estados del proceso:
        <div
            class="mr-1 status-pill green"
            data-title="Aperturado"
            data-toggle="tooltip"
          ></div>Aperturado
          <div
            class="ml-2 mr-1 status-pill yellow"
            data-title="Pendiente"
            data-toggle="tooltip"
          ></div>Pendiente
          <div
            class="ml-2 mr-1 status-pill blue"
            data-title="Corte"
            data-toggle="tooltip"
          ></div>Cerrado
          <div
            class="ml-2 mr-1 status-pill dark"
            data-title="Finalizado"
            data-toggle="tooltip"
          ></div>Finalizado
          <div
            class="ml-2 mr-1 status-pill red"
            data-title="Auditado"
            data-toggle="tooltip"
          ></div>Auditado
        </small> <br><br>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-6">
              <div align="right">
                <div class="col-sm-6">
                  <form action="#" class="form-inline justify-content-sm-end">
                    <div class="input-group-append">
                      <select
                        class="form-control form-control-sm rounded bright"
                        v-model="filtro_tienda"
                        @change="filterData"
                        style="width: 150px"
                      >
                        <option value>Tiendas</option>
                        <option
                          v-for="data in tiendas"
                          :value="data.codigo"
                          v-bind:key="data.id"
                        >
                          {{ data.nombre }}
                        </option>
                      </select>
                      <select
                        class="form-control form-control-sm rounded bright"
                        v-model="filter_caja"
                        @change="filterData"
                        style="width: 150px"
                      >
                        <option value>Cajas</option>
                        <option
                          v-for="data in cajas"
                          :value="data.id"
                          v-bind:key="data.id"
                        >
                          {{ data.caja }}
                        </option>
                      </select>
                      <select
                        class="form-control form-control-sm rounded bright"
                        v-model="filtro_estado"
                        @change="filterData"
                        style="width: 150px"
                      >
                        <option value>Estados</option>
                        <option
                          v-for="estado in estadosCorte"
                          :value="estado.llave"
                          v-bind:key="estado.llave"
                        >
                          {{ estado.valor }}
                        </option>
                      </select>
                      <input
                        type="date"
                        @change="filterData"
                        v-model="searchtext"
                        style="width: 150px"
                        class="form-control form-control-sm rounded bright"
                      />
                      <input
                        class="form-control form-control-sm rounded bright"
                        placeholder="Search"
                        v-model="searchtext"
                        type="text"
                        style="width: 300px"
                        v-on:keyup.enter="filterData"
                      />
                      <button
                        class="btn btn-link btn-sm"
                        type="button"
                        v-on:click="clearFilterData"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                      <button
                        class="btn btn-link btn-sm"
                        type="button"
                        v-on:click="filterData"
                        style="width: 60px"
                      >
                        <i class="fa fa-search"></i>
                        Buscar
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Cajero</th>
                <th scope="col">Caja</th>
                <th scope="col" class="text-center">Tienda</th>
                <th scope="col" class="text-center">Monto de Apertura</th>
                <th scope="col" class="text-center">Monto de Detalle</th>
                <th scope="col" class="text-center">Monto Total de Cierre</th>
                <th scope="col" class="text-center">Estado</th>
                <th scope="col" class="text-center">Fecha Apertura</th>
                <th scope="col" class="text-center">Fecha Cierre</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td>{{ current.numero }}</td>
                <td scope="row">{{ current.usuario.name }}</td>
                <td scope="row">{{ current.caja.caja }}</td>
                <td class="text-center">{{ current.tienda.codigo }}</td>
                <td class="text-center">{{ current.monto_apertura }}</td>
                <td class="text-center">{{ current.total_detalle }}</td>
                <td class="text-center">{{ current.monto_total }}</td>
                <td class="text-center">
                  <div
                    :class="{
                      'status-pill green':current.estado === 'A',
                      'status-pill yellow':current.estado === 'B',
                      'status-pill blue':current.estado === 'C',
                      'status-pill dark': current.estado === 'F',
                      'status-pill red': current.estado === 'Z',
                    }"
                    :data-title="current.estado_corte"
                    data-toggle="tooltip"
                  ></div>   
                </td>
                <td class="text-center">
                  {{ current.fecha_apertura | moment("DD/MM/YYYY") }}
                </td>
                <td class="text-center">
                  {{ current.fecha_cierre | moment("DD/MM/YYYY") }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CorteCajaService from "@/services/cxc/CorteCajaService";
import DynamicService from "@/services/commons/DynamicService";
import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      filter_fecha: "",
      cajas: [],
      estadosCorte:[],
      mostrarRefresh: false,
      filter_caja: "",
      currentPage: 1,
      searchtext: "",
      filterActiva: 1,
      data: [],
      filtro_tienda: "",
      filtro_estado: "",
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      CorteCajaService.getById(this.$route.params.id).then((response) => {
        this.current = response.data;
        this.current.errors = [];
        this.current.id;
      });
    }
    this.refreshcajas();
    this.refreshTienda();
    this.clearFilterData();
    this.getEstadosCorte();
  },
  methods: {
    getEstadosCorte(){
      let self = this;
      CorteCajaService.getActionSinId("lista_estados").then((response) => {
        self.estadosCorte = response.data;
      });
    },
    convertFormatDate() {
      this.filter_fecha = moment(this.filter_fecha).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      console.log(this.filter_fecha);
    },
    refreshcajas() {
      let self = this;
      DynamicService.fetch("cxc", "caja").then((response) => {
        self.cajas = response.data.results;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxc-corte-caja-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxc-corte-caja-editar",
          params: { id: current.id },
        });
      }
    },
    refreshTienda() {
      let self = this;
      self.$store.dispatch("catalogos/tiendas", {
        quitar_paginacion: true,
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        caja: this.filter_caja,
        page: this.currentPage,
        "filter[search]": this.searchtext,
        tienda: this.filtro_tienda,
      });
    },
    filterData() {
      this.convertFormatDate();
      this.refreshData({
        page: 1,
        caja: this.filter_caja,
        "filter[search]": this.searchtext,
        tienda: this.filtro_tienda,
        estado: this.filtro_estado,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filter_caja = "";
      this.filterActiva = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filtro_tienda,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      CorteCajaService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    showModalEdit() {},
  },
};
</script>
